import React, { useState } from 'react';

export function HelpTip({ text, width = 220 }) {
  const [show, setShow] = useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}>
      <button
        type="button"
        aria-label="More information"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onFocus={() => setShow(true)}
        onBlur={() => setShow(false)}
        style={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: 'var(--surface-3)',
          border: '1px solid var(--line)',
          color: 'var(--ink-3)',
          fontSize: 9.5,
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'default',
          flexShrink: 0,
          lineHeight: 1,
        }}
      >
        ?
      </button>
      {show && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 8px)',
            left: '50%',
            transform: 'translateX(-50%)',
            width,
            background: 'var(--surface)',
            border: '1px solid var(--line)',
            borderRadius: 10,
            padding: '8px 12px',
            fontSize: 12,
            lineHeight: 1.5,
            color: 'var(--ink-2)',
            boxShadow: 'var(--shadow-md)',
            zIndex: 200,
            pointerEvents: 'none',
            textAlign: 'left',
            whiteSpace: 'normal',
          }}
        >
          {text}
        </span>
      )}
    </span>
  );
}
